"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterItems = void 0;
function filterItems(items, filter) {
    const entries = Object.entries(filter);
    return items.filter((item) => {
        return entries.map(([taxonomy, term]) => {
            return term === null || item.terms[taxonomy].includes(term);
        }).every((flag) => flag);
    });
}
exports.filterItems = filterItems;
